import { model as storageCreateSelector } from '@features/storage-create-warehouse';
import { model as storageViewer } from '@widgets/storage-viewer';
import { createGate, sample } from '@lib/state-engine';

const { selectSleeveWarehouse, selectStationaryWarehouse } = storageCreateSelector;
const { addSleeveWarehouse, addStationaryWarehouse } = storageViewer;

export const PageGate = createGate();

sample({
  clock: selectSleeveWarehouse,
  filter: PageGate.status,
  target: addSleeveWarehouse,
});

sample({
  clock: selectStationaryWarehouse,
  filter: PageGate.status,
  target: addStationaryWarehouse,
});
